export default "__VITE_ASSET__DENFCGGb__"